const DATA_TRACKING_KEY_VALUE_PAIRS = {
  // monitoring map controls
  'monitoring-alerts-button': 'monitoring-alerts-button',
  'monitoring-back-to-real-time-button': 'monitoring-back-to-real-time-button',
  'monitoring-change-facility-button': 'monitoring-change-facility-button',
  'monitoring-map': 'monitoring-map',
  'monitoring-map-grid-toggle': 'monitoring-map-grid-toggle',
  'monitoring-map-reset-button': 'monitoring-map-reset-button',
  'monitoring-map-time-selector': 'monitoring-map-time-selector',
  'monitoring-sensor-group-item': 'monitoring-sensor-group-item',
  'monitoring-sensor-group-item-custom': 'monitoring-sensor-group-item-custom',
  'monitoring-sensor-group-selector': 'monitoring-sensor-group-selector',
  'monitoring-weather-station-item': 'monitoring-weather-station-item',
  'monitoring-weather-stations-selector': 'monitoring-weather-stations-selector',

  // general map controls
  'zoom-in-button': 'zoom-in-button',
  'zoom-out-button': 'zoom-out-button',

  // monitoring map layers controls
  'map-layers-activity-location-toggle': 'map-layers-activity-location-toggle',
  'map-layers-all-monitors-toggle': 'map-layers-all-monitors-toggle',
  'map-layers-button': 'map-layers-button',
  'map-layers-custom-image-overlays-toggle': 'map-layers-custom-image-overlays-toggle',
  'map-layers-diagnostics-influence-arcs-toggle': 'map-layers-diagnostics-influence-arcs-toggle',
  'map-layers-diagnostics-turn-off-toggle': 'map-layers-diagnostics-turn-off-toggle',
  'map-layers-exceeding-monitors-toggle': 'map-layers-exceeding-monitors-toggle',
  'map-layers-monitor-names-toggle': 'map-layers-monitor-names-toggle',
  'map-layers-other-monitor-position-toggle': 'map-layers-other-monitor-position-toggle',
  'map-layers-source-area-toggle': 'map-layers-source-area-toggle',

  // shared map layers controls
  'map-layers-domain-boundaries-toggle': 'map-layers-domain-boundaries-toggle',
  'map-layers-KML-overlays-toggle': 'map-layers-KML-overlays-toggle',
  'map-layers-roadmap-button': 'map-layers-roadmap-button',
  'map-layers-satellite-button': 'map-layers-satellite-button',
  'map-layers-satellite-greyscale-button': 'map-layers-satellite-greyscale-button',

  // monitoring map
  'monitoring-monitor-marker': 'monitoring-monitor-marker',
  'monitoring-weather-marker': 'monitoring-weather-marker',

  // monitoring playback
  'monitoring-playback-point': 'monitoring-playback-point',
  'monitoring-playback-alert-point-view-alert': 'monitoring-playback-alert-point-view-alert',
  'monitoring-playback-alert-point-run-trajectory': 'monitoring-playback-alert-point-run-trajectory',
  'monitoring-playback-timeline': 'monitoring-playback-timeline',
  'monitoring-playback-timeline-slider-handle': 'monitoring-playback-timeline-slider-handle',

  // grid view
  'grid-add-card-button': 'grid-add-card-button',
  'grid-chart-card': 'grid-chart-card',
  'grid-chart-card-drag-handle': 'grid-chart-card-drag-handle',
  'grid-sort-by-alphabetical': 'grid-sort-by-alphabetical',
  'grid-sort-by-button': 'grid-sort-by-button',
  'grid-sort-by-highest-exceedance': 'grid-sort-by-highest-exceedance',
  'grid-sort-by-highest-value': 'grid-sort-by-highest-value',

  // analyse drawer
  'analyse-drawer-chart': 'analyse-drawer-chart',
  'analyse-drawer-close-button': 'analyse-drawer-close-button',
  'analyse-drawer-date-range-last-6-hours': 'analyse-drawer-date-range-last-6-hours',
  'analyse-drawer-date-range-last-7-days': 'analyse-drawer-date-range-last-7-days',
  'analyse-drawer-date-range-last-24-hours': 'analyse-drawer-date-range-last-24-hours',
  'analyse-drawer-date-range-last-hour': 'analyse-drawer-date-range-last-hour',
  'analyse-drawer-date-range-selector-button': 'analyse-drawer-date-range-selector-button',
  'analyse-drawer-centre-map-on-monitor-button': 'analyse-drawer-centre-map-on-monitor-button',
  'analyse-drawer-process-variable': 'analyse-drawer-process-variable',
  'analyse-drawer-resize-drag-handle': 'analyse-drawer-resize-drag-handle',
  'analyse-drawer-threshold-toggle': 'analyse-drawer-threshold-toggle',

  // main navigation bar top items
  'main-nav-bar-logo': 'main-nav-bar-logo',
  'main-nav-bar-overview-link': 'main-nav-bar-overview-link',
  'main-nav-bar-monitoring-link': 'main-nav-bar-monitoring-link',
  'main-nav-bar-modelling-link': 'main-nav-bar-modelling-link',
  'main-nav-bar-alerts-link': 'main-nav-bar-alerts-link',
  'main-nav-bar-trajectories-link': 'main-nav-bar-trajectories-link',
  'main-nav-bar-blasting-link': 'main-nav-bar-blasting-link',
  'main-nav-bar-incident-intelligence-link': 'main-nav-bar-incident-intelligence-link',
  'main-nav-bar-annotations-link': 'main-nav-bar-annotations-link',
  'main-nav-bar-reports-link': 'main-nav-bar-reports-link',
  'main-nav-bar-updates-link': 'main-nav-bar-updates-link',

  // main navigation bar bottom items
  'main-nav-bar-site-config-link': 'main-nav-bar-site-config-link',
  'main-nav-bar-user-settings-link': 'main-nav-bar-user-settings-link',
  'main-nav-bar-support-link': 'main-nav-bar-support-link',
  'main-nav-bar-logout-link': 'main-nav-bar-logout-link',

  // model setup
  'modelling-setup-model-intervals': 'modelling-setup-model-intervals',
  'modelling-setup-date-time': 'modelling-setup-date-time',
  'modelling-setup-model-from': 'modelling-setup-model-from',
  'modelling-setup-model-to': 'modelling-setup-model-to',
  'modelling-setup-auto-update': 'modelling-setup-auto-update',

  // models list
  'modelling-list-model-toggle': 'modelling-list-model-toggle',

  // emission sources
  'modelling-emission-sources-toggle': 'modelling-emission-sources-toggle',

  // modelling time slider
  'modelling-time-slider': 'modelling-time-slider',
  'modelling-time-slider-play': 'modelling-time-slider-play',
  'modelling-time-slider-pause': 'modelling-time-slider-pause',

  // alert history - date range filter
  'alert-history-filter-date-range-apply': 'alert-history-filter-date-range-apply',
  'alert-history-filter-date-range-clear': 'alert-history-filter-date-range-clear',

  // alert history - type filter
  'alert-history-filter-type-option': 'alert-history-filter-type-option',
  'alert-history-filter-type-clear': 'alert-history-filter-type-clear',

  // alert history - alert filter
  'alert-history-filter-alert-option': 'alert-history-filter-alert-option',
  'alert-history-filter-alert-clear': 'alert-history-filter-alert-clear',

  // alert history - monitor filter
  'alert-history-filter-monitor-option': 'alert-history-filter-monitor-option',
  'alert-history-filter-monitor-clear': 'alert-history-filter-monitor-clear',

  // alert history - response filter
  'alert-history-filter-response-option': 'alert-history-filter-response-option',
  'alert-history-filter-response-clear': 'alert-history-filter-response-clear',

  // alert history - state filter
  'alert-history-filter-response-state-option': 'alert-history-filter-response-state-option',
  'alert-history-filter-response-state-clear': 'alert-history-filter-response-state-clear',

  // alert history - action by filter
  'alert-history-filter-action-by-option': 'alert-history-filter-action-by-option',
  'alert-history-filter-action-by-clear': 'alert-history-filter-action-by-clear',

  // alert history - alert link
  'alert-history-alert-link': 'alert-history-alert-link',

  // pagination
  'pagination-previous': 'pagination-previous',
  'pagination-next': 'pagination-next',
  'pagination-number': 'pagination-number',

  // Historical reports
  'historical-reports-download-link': 'historical-reports-download-link',
  'historical-reports-filter-option-report-definition': 'historical-reports-filter-option-report-definition',
  'historical-reports-filter-option-report-year': 'historical-reports-filter-option-report-year',

  // event history - date range filter
  'event-history-filter-date-range-apply': 'event-history-filter-date-range-apply',
  'event-history-filter-date-range-clear': 'event-history-filter-date-range-clear',

  // event history - monitor filter
  'event-history-filter-monitor-option': 'event-history-filter-monitor-option',
  'event-history-filter-monitor-clear': 'event-history-filter-monitor-clear',

  // event history - classification filter
  'event-history-filter-classification-option': 'event-history-filter-classification-option',
  'event-history-filter-classification-clear': 'event-history-filter-classification-clear',

  // event history - classification state filter
  'event-history-filter-classification-state-option': 'event-history-filter-classification-state-option',
  'event-history-filter-classification-state-clear': 'event-history-filter-classification-state-clear',

  // event history - classification state filter
  'event-history-filter-disregard-state-option': 'event-history-filter-disregard-state-option',
  'event-history-filter-disregard-state-clear': 'event-history-filter-disregard-state-clear',

  // event history - event listing row
  'event-history-event-row': 'event-history-event-row',

  // event history - event details - waveform
  'event-history-waveform-button': 'event-history-waveform-button',
  'event-history-spectrogram-button': 'event-history-spectrogram-button',
  'event-history-download-button': 'event-history-download-button',
  'event-history-wave-surfer-playback': 'event-history-wave-surfer-playback',
  'event-history-playback-slider': 'event-history-playback-slider',
  'event-history-playback-play-button': 'event-history-playback-play-button',
  'event-history-playback-pause-button': 'event-history-playback-pause-button',

  // event history - event details - classification
  'event-history-classification-buttons': 'event-history-classification-buttons',
  'event-history-comments': 'event-history-comments',
  'event-history-disregard-button': 'event-history-disregard-button',
  'event-history-disregard-tooltip': 'event-history-disregard-tooltip',
  'event-history-save-button': 'event-history-save-button',
  'event-history-discard-button': 'event-history-discard-button',

  // trajectories - create new trajectory button
  'trajectories-create-new-button': 'trajectories-create-new-button',

  // trajectories - date range filter
  'trajectories-filter-date-range-apply': 'trajectories-filter-date-range-apply',
  'trajectories-filter-date-range-clear': 'trajectories-filter-date-range-clear',

  // trajectories - created by filter
  'trajectories-filter-created-by-option': 'trajectories-filter-created-by-option',
  'trajectories-filter-created-by-clear': 'trajectories-filter-created-by-clear',

  // trajectories - observation time filter
  'trajectories-filter-observation-time-apply': 'trajectories-filter-observation-time-apply',
  'trajectories-filter-observation-time-clear': 'trajectories-filter-observation-time-clear',

  // trajectories - trajectory type filter
  'trajectories-filter-trajectory-type-option': 'trajectories-filter-trajectory-type-option',
  'trajectories-filter-trajectory-type-clear': 'trajectories-filter-trajectory-type-clear',

  // trajectories - status filter
  'trajectories-filter-status-option': 'trajectories-filter-status-option',
  'trajectories-filter-status-clear': 'trajectories-filter-status-clear',

  // trajectories - trajectory list
  'trajectories-view-details': 'trajectories-view-details',
  'trajectories-action-button': 'trajectories-action-button',
  'trajectories-action-button-duplicate': 'trajectories-action-button-duplicate',
  'trajectories-action-button-delete': 'trajectories-action-button-delete',

  // trajectories - trajectory details sidebar
  'trajectories-details-duplicate-button': 'trajectories-details-duplicate-button',
  'trajectories-details-export-button': 'trajectories-details-export-button',
  'trajectories-details-delete-button': 'trajectories-details-delete-button',

  // trajectories - map layers controls
  'trajectories-map-layers-show-monitors-button': 'trajectories-map-layers-show-monitors-button',

  // trajectories - particle elevation
  'trajectories-particle-elevation-path-button': 'trajectories-particle-elevation-path-button',
  'trajectories-particle-elevation-points-button': 'trajectories-particle-elevation-points-button',
  'trajectories-time-step-slider': 'trajectories-time-step-slider',
} as const;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const DATA_TRACKING_KEY_VALUES = Object.values(DATA_TRACKING_KEY_VALUE_PAIRS);

export type DataTrackingKeys = (typeof DATA_TRACKING_KEY_VALUES)[number];

export const DATA_TRACKING_KEY: { [Key in DataTrackingKeys]: Key } = {
  ...DATA_TRACKING_KEY_VALUE_PAIRS,
};
